import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import TextareaAutosize from 'react-textarea-autosize';
import {useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import useForm from "../../../../hooks/useForm";
import URLS from "../../../../API/Axios/URLS";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import AnswerDropDown from "../component/AnswerDropDown";
import GenericQuestionModal from "../Modal/GenericQuestionModal/GenricQuestionModal";
import {tokenizeSentence} from "../../../../utils/utils";


export default function InteractiveWriting({className, ...props}) {
    const {question, questionActions} = useQuestion()
    const [showModal, setShowModal] = useState(false)
    const {id} = useParams()
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: "",
        time: 0,
        answer2: "",
        time2: 0
    })
    const [response, setResponse] = useState({})
    const [active, setActive] = useState(0)


    function submitAnswer() {
        actions.setError({})
        let minWords = 50;
        // to integer
        minWords = Math.floor(minWords)
        if (tokenizeSentence(form?.answer).length < minWords && active === 0) {
            actions.setError({
                non_field_errors: [`Answer should be at least ${minWords} words`]
            })
            return
        } else if (tokenizeSentence(form?.answer2).length < 30 && active === 1) {
            actions.setError({
                non_field_errors: [`Answer should be at least ${30} words`]
            })
            return
        }
        if (active === 0) {
            setActive(1)
            return
        }
        actions.post(URLS.genericQuestionView, (data) => {
            let totalTimeInSec = (Date.now() - data.time) / 1000
            // remove decimal points
            totalTimeInSec = Math.floor(totalTimeInSec)

            return {
                ...data,
                time: totalTimeInSec
            }
        }).then(response => {
            setResponse(response?.data)
            setShowModal(true)
            setFormData({
                time: 0
            })
        })

    }


    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [id])


    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}
                             timeLimit={question?.timeLimit && question?.timeLimit + 30000}

            />
            <GenericQuestionModal
                result={response}
                showModal={showModal} setShowModal={setShowModal}/>
            <div className={" flex flex-col items-center md:flex-row p-2 py-8 justify-center gap-8"}>

                <div className={"flex flex-1 px-8 flex-col gap-4"}>
                    <div className={"grid grid-cols-1 lg:grid-cols-2 gap-4"}>
                        <div className={"flex flex-col gap-2"}>
                            <p className={"text-lg font-semibold"}>{question?.items?.[0]?.text}</p>
                            <TextareaAutosize
                                minRows={10}
                                disabled={active !== 0}
                                placeholder="Write your answer here"
                                value={form?.answer}
                                onChange={(e) => {
                                    if (form.time === 0) {
                                        form.time = Date.now()
                                    }
                                    setFormData({
                                        answer: e.target.value
                                    })
                                }}

                                className="w-full  disabled:bg-gray-200 rounded-lg border-[1.5px] text-black-2 dark:text-white border-b-graydark bg-white py-2 px-2 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            ></TextareaAutosize>
                            <div className={"flex w-full flex-row-reverse"}>
                                Word Count
                                : {form?.answer.trim().length !== 0 ? form?.answer.trim().split(" ").length : "0"}
                            </div>
                        </div>
                        <div className={"flex flex-col gap-2"}>
                            <p className={"text-lg font-semibold"}>{question?.items?.[1]?.text}</p>
                            <TextareaAutosize
                                minRows={10}
                                disabled={active !== 1}
                                placeholder="Write your answer here"
                                value={form?.answer2}
                                onChange={(e) => {
                                    if (form?.time2 === 0) {
                                        form.time2 = Date.now()
                                    }
                                    setFormData({
                                        answer2: e.target.value
                                    })
                                }}

                                className="w-full disabled:bg-gray-200 rounded-lg border-[1.5px] text-black-2 dark:text-white border-b-graydark bg-white py-2 px-2 font-medium outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary"
                            ></TextareaAutosize>
                            <div className={"flex w-full flex-row-reverse"}>
                                Word Count
                                : {form?.answer2.trim().length !== 0 ? form?.answer2.trim().split(" ").length : "0"}
                            </div>
                        </div>
                    </div>
                    <FormNoneFieldErrors errors={error?.answer || error?.non_field_errors}/>

                </div>


            </div>
            <QuestionFooter className={"mx-4 my-2"}
                            loading={loading}
                            disabled={!response}
                            submitText={active === 0 ? "Next" : "Submit"}
                            onClickSubmit={submitAnswer}

            />

            <AnswerDropDown
                className={" mt-4 "}
                headerTitle={"Show Answer"}
                 justifications={question?.items?.[0]?.answerText}
                justifications2={question?.items?.[1]?.answerText}
            />

        </div>

    )


}
